import React, { useState, useEffect, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AnnouncementService } from '../../../service/manage/announcement/announcement.service';
import { HiInbox } from 'react-icons/hi2';
import './NotificationDropdown.css';

const NotificationDropdown = ({ isOpen, onClose }) => {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);
    const dropdownRef = useRef(null);
    const history = useHistory();

    useEffect(() => {
        if (isOpen) {
            loadAnnouncements();
        }
    }, [isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                const notificationBtn = document.getElementById('kt_quick_notifications_toggle');
                if (notificationBtn && !notificationBtn.contains(event.target)) {
                    onClose();
                }
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    const loadAnnouncements = async () => {
        try {
            setLoading(true);
            const userId =
                sessionStorage.getItem("lg_user_id") ||
                sessionStorage.getItem("manage_user_id");

            const userTableId =
                sessionStorage.getItem("lg_user_table_id") ||
                sessionStorage.getItem("table_log_id");

            if (!userId || !userTableId) {
                setAnnouncements([]);
                return;
            }

            const response = await AnnouncementService.getLastWeekAnnouncementsByUser(
                userId,
                userTableId
            );

            if (response?.success) {
                setAnnouncements((response.data?.announcements || []).slice(0, 5));
            } else {
                setAnnouncements([]);
            }
        } catch (error) {
            console.error("Error loading announcements:", error);
            setAnnouncements([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAnnouncementClick = () => {
        onClose();
        history.push('/announcements');
    };

    const formatTime = (dateString) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            const now = new Date();
            const diffInMs = now - date;
            const diffInMins = Math.floor(diffInMs / 60000);
            const diffInHours = Math.floor(diffInMs / 3600000);
            const diffInDays = Math.floor(diffInMs / 86400000);

            if (diffInMins < 1) return 'Just now';
            if (diffInMins < 60) return `${diffInMins} min${diffInMins > 1 ? 's' : ''} ago`;
            if (diffInHours < 24) return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
            if (diffInDays < 7) return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;

            return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        } catch (e) {
            return dateString;
        }
    };

    if (!isOpen) return null;

    return (
        <div className="notification-dropdown" ref={dropdownRef}>
            <div className="notification-dropdown-header">
                <h3 className="notification-dropdown-title">Notifications</h3>
            </div>

            <div className="notification-dropdown-content">
                {loading ? (
                    <div className="notification-loading">
                        <div className="loading-spinner-small"></div>
                        <p>Loading...</p>
                    </div>
                ) : announcements.length === 0 ? (
                    <div className="notification-empty">
                        <HiInbox className="notification-empty-icon" />
                        <p>No new notifications</p>
                    </div>
                ) : (
                    <div className="notification-list">
                        {announcements.map((announcement) => (
                            <div
                                key={announcement.announcement_id}
                                className="notification-item"
                                onClick={handleAnnouncementClick}
                            >
                                <div className="notification-indicator"></div>
                                <div className="notification-content">
                                    <h4 className="notification-title">
                                        {announcement.announcement_title}
                                    </h4>
                                    <p className="notification-description">
                                        {announcement.announcement_body}
                                    </p>
                                    <span className="notification-time">
                                        {formatTime(announcement.created_at)}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <div className="notification-dropdown-footer">
                <Link to="/announcements" className="notification-see-more" onClick={onClose}>
                    See more
                </Link>
            </div>
        </div>
    );
};

export default NotificationDropdown;
